import { css } from 'styled-components'

export const theme = {
  maxWidth: '768px',
  mobileMaxWidth: '320px',
  color: {
    primaryColor: '#a38e63',
    secondaryColor: '#F2A840',
    offWhite: '#FFFFFF',
    coolGrey: '#929497',
    charcoalGrey: '#49484a',
    purplishGrey: '#5a595b',
    silver: '#d9d9da',
    // paleGrey: '#f7f7f8',
    paleGrey: '#dfdfdf',
    heather: '#c0bfc1',
    black: '#202020',
    warning: '#e7a957',
    success: '#34a820',
    error: '#c7442a',
  },
  fonts: {
    family: {
      normal: 'lato',
    },
    style: {
      extraLight: '300',
      light: '300',
      regular: '400',
      bold: '700',
      black: '900',
    },
    size: {
      heading: '56px',
      subHeading: '40px',
      title: '30px',
      subTitle: '22px',
      normal: '16px',
      small: '14px',
      label: '12px',
    },
  },
}

export const screenSize = {
  mobileS: 320,
  mobileM: 375,
  mobileL: 425,
  tablet: 768,
  laptop: 1024,
  laptopL: 1440,
  desktop: 2560,
}

export const media = Object.keys(screenSize).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media only screen and (max-width: ${screenSize[label]}px) {
      ${css(...args)}
    }
  `

  return acc
}, {})

export default theme



// WEBPACK FOOTER //
// ./src/styles/_variables.js